import { Const } from '~/constants/Const.constant';
import { battery } from '~/helpers/fields-description';
import { VeluxModule } from '~/models/modules/velux/VeluxModule.model';

export class NXD extends VeluxModule {

    battery_levels = {
        full: Const.NABatteryLevelNXD.NXD_LEVEL_0,
        high: Const.NABatteryLevelNXD.NXD_LEVEL_1,
        medium: Const.NABatteryLevelNXD.NXD_LEVEL_2,
        low: Const.NABatteryLevelNXD.NXD_LEVEL_3,
    };

    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery_vp), this.battery_vp);
    }

}
